import React, { useState, useEffect, useContext } from 'react';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Link } from 'react-router-dom';
import { KeyVaultMenuItems, KeyVaultMenuProps } from '../Model/KeyVaultModel';
import { PermissionsContext } from '../../UIContainer/PermissionsWrapper';
import { Dictionary } from '../../../Common/CommonModel';

const useStyles = makeStyles()(() => ({
  menu: {
    padding: 0,
  },
}));

const menuItems: KeyVaultMenuItems[] = [
  {
    id: 'edit',
    label: 'Edit',
    linkTo: '/keyvault/{0}/key/{1}',
    validationFunc: 'edit',
  },
  {
    id: 'delete',
    label: 'Delete',
    linkTo: '/keyvault/{0}/key/{1}',
    validationFunc: 'delete',
  },
];

export default function KeyVaultMenu(props: KeyVaultMenuProps) {
  const { KeyName } = props;
  const { classes } = useStyles();
  const [anchor, setAnchor] = useState<HTMLButtonElement | null>(null);
  const [menuState, setMenuState] = useState(false);
  const permissions = useContext(PermissionsContext);
  useEffect(() => {}, []);

  const openKeyVaultMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuState(true);
    setAnchor(event.currentTarget);
  };
  const closeKeyVaultMenu = () => {
    setMenuState(false);
    setAnchor(null);
  };

  const haskeyVaultWritePermission = () =>
    permissions['SecureKeyWriter'] ? true : false;

  function executeValidationMethod(type: string) {
    let fn;
    const validations: Dictionary<() => boolean> = {};
    validations['edit'] = () => haskeyVaultWritePermission();
    validations['delete'] = () => haskeyVaultWritePermission();
    validations['default'] = () => false;

    if (validations[type]) {
      fn = validations[type];
    } else {
      fn = validations['default'];
    }
    return fn();
  }

  return (
    <div>
      <IconButton
        aria-label="More"
        aria-owns="long-menu"
        aria-haspopup="true"
        onClick={openKeyVaultMenu}
        className={classes.menu}
        size="large"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchor}
        open={menuState}
        onClose={closeKeyVaultMenu}
      >
        {menuItems
          .filter((menu) => executeValidationMethod(menu.validationFunc))
          .map((menu) => (
            <MenuItem
              key={menu.id}
              component={Link}
              to={menu.linkTo.format(menu.id, KeyName)}
            >
              {menu.label}
            </MenuItem>
          ))}
      </Menu>
    </div>
  );
}
